import { call, options, params } from './helpers';

export const searchGlobally = (payload) =>
	call(`/beta/search${params(payload)}`);
